import React from 'react';
import Navbar from './Navbar';
import HeroContent from './HeroContent';

export default function Hero({ activeVideo, onVideoChange, onOpenContact }) {
  return (
    <section className="relative w-full min-h-screen flex flex-col">
      <Navbar />
      <HeroContent 
        activeVideo={activeVideo} 
        onVideoChange={onVideoChange} 
        onOpenContact={onOpenContact} 
      />
      
      {/* Bottom Stats - always white */}
      <div className="pb-8 px-6 z-20 relative w-full font-sans text-white/70 text-xs sm:text-sm">
        <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-4 max-w-4xl mx-auto">
          <span>7-Day Delivery</span>
          <span className="hidden sm:inline opacity-50">|</span>
          <span>50% Deposit to Book</span>
          <span className="hidden sm:inline opacity-50">|</span>
          <span>Fixed Pricing</span>
          <span className="hidden sm:inline opacity-50">|</span>
          <span>Files Yours on Delivery</span>
        </div>
      </div>
    </section>
  );
}